import React, {Fragment} from "react";
import { styles } from './SidebarBaseMenuIcon';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(styles);

const HistoryLeftArrowIcon = () => {
    const classes = useStyles();
    return (
        <Fragment>
            <img src={require('../../assets/icons/History_ArrowLeft.svg')} alt={'alt'} className={classes.iconWidth}  />
        </Fragment>
    )
}

export default HistoryLeftArrowIcon;
